<template>
  <div class="global-page">
    <!-- <titleBlock title="OTMS字段配置">
      <checkList
        title="订单管理字段(明细视角)"
        :options="configFields.orderListDetailFields"
        :checked="globalConfig.orderListDetailFields"
        @handleCheck="(val) => handleChange(val, 'orderListDetailFields')"
      />
      <checkList
        title="订单管理字段(聚合视角)"
        :options="configFields.orderListAggFields"
        :checked="globalConfig.orderListAggFields"
        @handleCheck="val => handleChange(val, 'orderListAggFields')"
      />
    </titleblock> -->
    <titleBlock title="货主端字段管理">
      <checkList
        :has-all="false"
        title="数据概览敏感字段"
        :checked="globalConfig.globalFields.dataOverviewSensitiveFields"
        :options="configFields.dataOverviewSensitiveFields"
        @handleCheck="(val) => handleChange(val, 'globalFields', 'dataOverviewSensitiveFields')"
      />
      <checkList
        :has-all="false"
        title="车辆轨迹敏感数据"
        :options="configFields.vehicleTrackSensitiveFields"
        :checked="globalConfig.globalFields.vehicleTrackSensitiveFields"
        @handleCheck="val => handleChange(val, 'globalFields', 'vehicleTrackSensitiveFields')"
      />
      <checkList
        :has-all="false"
        title="订单字段管理"
        :options="configFields.orderSensitiveFields"
        :checked="globalConfig.globalFields.orderSensitiveFields"
        @handleCheck="val => handleChange(val, 'globalFields', 'orderSensitiveFields')"
      />
    </titleblock>
    <titleBlock title="履约信息">
      <examineRange
        ref="examineRangeRef1"
        :detail="globalConfig.temperature.preCool"
        title="车辆预冷卡控"
        @handleChange="(val)=>handleChange(val,'temperature','preCool')"
      />
      <examineRange
        ref="examineRangeRef2"
        title="车辆发车温度卡控"
        :detail="globalConfig.temperature.departure"
        @handleChange="val => handleChange(val, 'temperature', 'departure')"
      />
      <template v-slot:info>
        <el-tooltip
          v-if="!globalConfig.temperature.edit"
          class="item"
          effect="dark"
          placement="top-start"
        >
          <i class="el-icon-question" />
          <div slot="content">
            客户存在审批中的履约信息修改，暂不允许编辑
          </div>
        </el-tooltip>
      </template>
      <warmRange
        ref="warmRange"
        title="车辆在途温度"
        :disabled="!globalConfig.temperature.edit"
        :checked="globalConfig.temperature"
        @handleCheck="val => handleChange(val, 'temperature')"
      />
      <examine
        title="车辆到达后不再考核温度"
        :checked="globalConfig.temperature.checkTemperature"
        @handleCheck="val => handleChange(val, 'temperature', 'checkTemperature')"
      />
    </titleBlock>
    <fix-boottom class="bottom_bar">
      <template slot="button">
        <el-button
          type="primary"
          :disabled="disabled"
          @click="handleSubmit"
        >
          保存并下一步
        </el-button>
        <el-button @click="onReturn">
          取消
        </el-button>
      </template>
    </fix-boottom>
  </div>
</template>

<script>
import { configList } from '@/api/configure/processNode';
import FixBoottom from '@/components/FixBoottom/index.vue';
import {
  isEqual, pick, isNil, omit,
} from 'lodash';
import { customerProcessRuleUpdate, customerProcessRuleCreate } from '../api';
import titleBlock from '../assembly/titleBlock.vue';
import checkList from '../assembly/checkList.vue';
import warmRange from '../assembly/warmRange.vue';
import examine from '../assembly/examine.vue';
import examineRange from '../assembly/examineRange.vue';
import { processModuleCode } from '../const';

export default {
  components: {
    titleBlock, checkList, warmRange, examine, FixBoottom, examineRange,
  },
  props: {
    code: {
      type: String,
      default: null,
    },
    globalConfig: {
      type: Object,
      default: () => ({
        globalFields: {},
        temperature: {},
      }),
    },
    temperature: {
      type: Object,
      default: () => {},
    },
    editTopStep: {
      type: Number,
      default: -1,
    },
    customersDetail: {
      type: Object,
      default: () => {},
    },
    isEidt: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      configFields: {},
      disabled: false,
    };
  },
  created() {
    this.getConfigList();
  },
  methods: {
    async getConfigList() {
      const [res] = await configList({ key: 'process_node_global_config' });
      const data = JSON.parse(res.value) || {};
      const list = {};
      Object.keys(data).forEach((item) => {
        list[item] = Object.keys(data[item]).map((child) => ({ value: child, label: data[item][child] }));
      });
      this.configFields = list;
    },
    handleChange(val, ...keys) {
      let data = this.globalConfig;
      while (keys.length) {
        const key = keys.shift();
        if (!keys.length) {
          data[key] = val;
        } else {
          data = data[key];
        }
      }
    },
    onReturn() {
      this.$router.back();
    },
    validateWarm(callback) {
      // 车辆遇冷卡控
      if (this.$refs.examineRangeRef1.$refs.form) {
        this.$refs.examineRangeRef1.$refs.form.validate();
      }
      // 车辆发车温度卡控
      if (this.$refs.examineRangeRef2.$refs.form) {
        this.$refs.examineRangeRef2.$refs.form.validate();
      }
      if (this.globalConfig.temperature.edit) {
        this.$refs.warmRange.validate((v) => {
          if (v) {
            callback();
          }
        });
      } else {
        callback();
      }
    },
    temperatureFormatter(list) {
      return list ? list.map((item) => {
        const newItem = {
          ...item,
          minMileage: !item.minMileage.length ? undefined : Number(item.minMileage),
          maxMileage: !item.maxMileage.length ? undefined : Number(item.maxMileage),
          minTemperature: !item.minTemperature.length ? undefined : Number(item.minTemperature),
          maxTemperature: !item.maxTemperature.length ? undefined : Number(item.maxTemperature),
        };
        const keys = Object.keys(newItem).filter((key) => isNil(newItem[key]));
        return omit(newItem, keys);
      }) : null;
    },
    async submit(formatTemperature) {
      const {
        customerCode, carrierTenantId, parentProcessCode, ruleVersion,
      } = this.customersDetail;
      const params = {
        customerCode,
        carrierTenantId,
        parentProcessCode,
        ruleVersion,
        processCode: this.code,
        processModuleCode: processModuleCode[3],
        processRules: [
          {
            ruleCode: 'GLOBAL_FIELDS',
            ruleValue: this.globalConfig.globalFields,
          },
          {
            ruleCode: 'TEMPERATURE',
            ruleValue: formatTemperature,
          },
        ],
      };

      try {
        this.disabled = true;
        const method = !this.isEidt.GLOBAL ? customerProcessRuleCreate : customerProcessRuleUpdate;
        await method({ ...params });
        this.disabled = false;
        this.$message.success('全局配置成功');
        this.$emit('finish', this.globalConfig);
      } catch (error) {
        this.disabled = false;
      }
    },
    handleSubmit() {
      this.validateWarm(async () => {
        const { temperature } = this.globalConfig;
        const formatTemperature = JSON.parse(JSON.stringify(temperature));
        formatTemperature.coldStorage = this.temperatureFormatter(formatTemperature.coldStorage);
        formatTemperature.freezing = this.temperatureFormatter(formatTemperature.freezing);
        if (temperature.edit && this.temperature && !isEqual(pick(formatTemperature, ['coldStorage', 'freezing']), pick(this.temperature, ['coldStorage', 'freezing']))) {
          this.$confirm('涉及车辆在途温度修改，将发送飞书审批，通过后自动生效', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(() => {
            this.submit(formatTemperature);
          });
        } else {
          this.submit(formatTemperature);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.global-page{
  width:100%;
  flex:1;
  background: #fff;
  padding:0 24px 24px;
  position:relative;
  padding-bottom: 60px;
  box-sizing: border-box;
  ::v-deep .title-block{
    border-bottom: 1px solid #D9DBDE;
    padding-top:24px;
  }
  .footer{
    height:56px;
    line-height: 56px;
    position:absolute;
    bottom:-24px;
    left:-24px;
    width:calc(100% + 48px);
    padding-left:24px;
    box-sizing: border-box;
    background: #fff;
  }
}
::v-deep.bottom_bar{
  .align-right{
    text-align: left;
  }
}
</style>
